<template>
    <div>
        <h4 class="is-size-4">Contenido</h4>
        <ol>
            <li class="is-size-5">
                <a href="/sepomex/colonias/#colonias">Colonias</a>
            </li>
            <li class="is-size-5">
                <a href="/sepomex/colonias/#colonia">Colonia</a>
            </li>
        </ol>
        <br>

        <h3 class="is-size-4" id="colonias">1.- Colonias</h3>
        <strong>
            Enpoint con la lista de colonias, siempre regresa un array de objetos, incluso aunque sea solo un elemento
        </strong>
        <br><br>
        <p>
            <code>GET {{ host }}/api/sepomex/colonias/</code>
        </p>

        <h5 class="is-size-6">Parametros opcionales para busqueda:</h5> 
        <div class="content">
            <ul>
                <li>
                    <strong>id</strong>
                    <ul>
                        <li>Opcional</li>
                        <li>Formato string (Ej. 1)</li>
                    </ul>
                </li>
                <li>
                    <strong>municipioId</strong>
                    <ul>
                        <li>Opcional</li>
                        <li>Formato string (Ej. 282)</li>
                    </ul>
                </li>
                <li>
                    <strong>activo</strong>
                    <ul>
                        <li>Opcional</li>
                        <li>Formato boolean (Ej. true, 1, yes, false, 0, no)</li>
                    </ul>
                </li>
                <li>
                    <strong>nombre</strong>
                    <ul>
                        <li>Opcional</li>
                        <li>Formato string (Ej. 'chihuahua' )</li>
                    </ul>
                </li>
                <li>
                    <strong>codigoPostal</strong>
                    <ul>
                        <li>Opcional</li>
                        <li>Formato string (Ej. '31000' )</li>
                    </ul>
                </li>
                <li>
                    <strong>detail</strong>
                    <ul>
                        <li>Opcional (aplicable solo si se busca por codigoPostal)</li>
                        <li>Anexa a la informacion de la colonia: municipioId, stateId</li>
                        <li>Formato boolean (true)</li>
                    </ul>
                </li>
            </ul>
        </div>

       
        <h5 class="is-size-6 has-text-weight-bold">Respuesta 1 de Ejemplo:</h5>
        <pre>
            <h5 class="has-text-link">GET {{ host }}/api/sepomex/colonias?municipioId=282</h5>
            <code>[
                {
                    "id": 20967,
                    "codigoPostal": "31000",
                    "nombre": "Chihuahua Centro",
                    "tipoAsentamiento": "Colonia",
                    "estado": "Chihuahua",
                    "municipio": "Chihuahua",
                    "ciudad": "Chihuahua",
                    "activo": true
                },
                {
                    "id": 20968,
                    "codigoPostal": "31000",
                    "nombre": "Sector Bolívar",
                    "tipoAsentamiento": "Colonia",
                    "estado": "Chihuahua",
                    "municipio": "Chihuahua",
                    "ciudad": "Chihuahua",
                    "activo": true
                },
                {
                    "id": 20969,
                    "codigoPostal": "31000",
                    "nombre": "Parque Rotario",
                    "tipoAsentamiento": "Colonia",
                    "estado": "Chihuahua",
                    "municipio": "Chihuahua",
                    "ciudad": "Chihuahua",
                    "activo": true
                },
                ...
            ]</code>
        </pre>
        <br><br>

        <h5 class="is-size-6 has-text-weight-bold">Respuesta 2 de Ejemplo:</h5>
        <pre>
            <h5 class="has-text-link">GET {{ host }}/api/sepomex/colonias?id=1</h5>
            <code>[
                {
                    "id": 1,
                    "codigoPostal": "20000",
                    "nombre": "Aguascalientes Centro",
                    "tipoAsentamiento": "Colonia",
                    "estado": "Aguascalientes",
                    "municipio": "Aguascalientes",
                    "ciudad": "Aguascalientes",
                    "activo": true
                }
            ]</code>
        </pre>
        <br><br>

        <h5 class="is-size-6 has-text-weight-bold">Respuesta 3 de Ejemplo:</h5>
        <pre>
            <h5 class="has-text-link">GET {{ host }}/api/sepomex/colonias?codigoPostal=31135&detail=true</h5>
            <code>[
                {
                    "id": 21342,
                    "codigoPostal": "31135",
                    "nombre": "CDP",
                    "tipoAsentamiento": "Colonia",
                    "estado": "Chihuahua",
                    "municipio": "Chihuahua",
                    "ciudad": "Chihuahua",
                    "activo": true,
                    "stateId": 8,
                    "municipioId": 282,
                    "countryId": "MEX"
                },
                {
                    "id": 21343,
                    "codigoPostal": "31135",
                    "nombre": "Francisco Domínguez",
                    "tipoAsentamiento": "Colonia",
                    "estado": "Chihuahua",
                    "municipio": "Chihuahua",
                    "ciudad": "Chihuahua",
                    "activo": true,
                    "stateId": 8,
                    "municipioId": 282,
                    "countryId": "MEX"
                },
                {
                    "id": 21344,
                    "codigoPostal": "31135",
                    "nombre": "Revolución",
                    "tipoAsentamiento": "Colonia",
                    "estado": "Chihuahua",
                    "municipio": "Chihuahua",
                    "ciudad": "Chihuahua",
                    "activo": true,
                    "stateId": 8,
                    "municipioId": 282,
                    "countryId": "MEX"
                }
            ]</code>
        </pre>
        <hr />

        <h3 class="is-size-3" id="colonia">2.- Colonia</h3>
        <strong>Enpoint con el detalle de un solo colonia, siempre regresa un objeto.</strong>
        <br><br>
        <p>
            <code>GET {{ host }}/api/sepomex/colonia/{id}</code>
        </p>

        <h5 class="is-size-6">Parametros:</h5> 
        <div class="content">
            <ul>
                <li>
                    <strong>id</strong>
                    <ul>
                        <li>Requerido</li>
                        <li>Formato number (Ej. 1)</li>
                    </ul>
                </li>
            </ul>
        </div>

        <h5 class="is-size-6 has-text-weight-bold">Respuesta de Ejemplo:</h5>
        <pre>
            <h5 class="has-text-link">GET {{ host }}/api/sepomex/colonia/1</h5>
            <code>{
                "id": 1,
                "codigoPostal": "20000",
                "nombre": "Aguascalientes Centro",
                "tipoAsentamiento": "Colonia",
                "estado": "Aguascalientes",
                "municipio": "Aguascalientes",
                "ciudad": "Aguascalientes",
                "activo": true
            }</code>
        </pre>
        <br><br>

        <h5 class="is-size-6 has-text-weight-bold">Respuesta 2 de Ejemplo:</h5>
        <pre>
            <h5 class="has-text-link">GET {{ host }}/api/sepomex/colonia/21186</h5>
            <code>{
                "id": 21186,
                "codigoPostal": "31107",
                "nombre": "Panorámico",
                "tipoAsentamiento": "Colonia",
                "estado": "Chihuahua",
                "municipio": "Chihuahua",
                "ciudad": "Chihuahua",
                "activo": true
            }</code>
        </pre>
        <br><br>

        <h5 class="is-size-6 has-text-weight-bold">Respuesta 3 de Ejemplo, colonia no encontrada:</h5>
        <pre>
            <h5 class="has-text-link">GET {{ host }}/api/sepomex/colonia/0</h5>
            <code>{}</code>
        </pre>
    </div>
</template>

<script>
export default {
    name: 'SepomexColonias',
    data () {
        return {
            host: process.env.VUE_APP_HOST
        }
    }
}
</script>

<style scoped>
p {
    margin-bottom: 15px;
}
</style>
